module.exports = __webpack_public_path__ + "static/media/contacts-men.969045b1.png";